<template>
  <div id="wrapper" class="font-fira">
    <TextHeader
      :headerTitle="$t('shop.title')"
      header-bg="radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #080806)"
    />
    <div id="content" class="w-container">
      <SectionHeader :text="$t('shop.title')" class="w-row" />
      <div class="row">
        <div
          class="col-12 col-md-6 col-lg-4"
          v-for="item of items"
          :key="item.id"
        >
          <div
            class="shop-item rounded"
            v-b-modal.shop-details
            @click="selectItem(item)"
          >
            <img :src="getImage(item)" class="w-100" />
            <h3 class="title px-3">
              {{ item.title }}
            </h3>
            <h5 class="price mb-0 text-info">
              <span :style="{'text-decoration': item.soldOut ? 'line-through' : undefined}">{{ item.price
              }}<small
                v-if="item.oldPrice && !item.soldOut"
                style="text-decoration: line-through"
                class="ml-1"
                >{{ item.oldPrice }}</small
              >
                Lei</span><span class="ml-2" v-if="item.soldOut">[SOLD OUT]</span>
            </h5>
            <div class="buy" @click.stop.prevent="buy(item)" v-if="!item.soldOut">
              <b-icon-cart></b-icon-cart>
              {{ $t("shop.buy") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="shop-details"
      :hide-header="true"
      :hide-footer="true"
      size="xl"
    >
      <shop-details v-if="selectedItem" :item="selectedItem"></shop-details>
    </b-modal>
  </div>
</template>

<script>
import TextHeader from "./TextHeader";
import SectionHeader from "./SectionHeader";
import ShopDetails from "@/components/ShopDetails";
import { mapState } from "vuex";

export default {
  name: "Shop",
  components: { ShopDetails, SectionHeader, TextHeader },
  created() {
    this.$store.dispatch("products/getAllProducts");
  },
  data() {
    return {
      selectedItem: null,
      cart: [],
    };
  },
  computed: mapState({ items: (state) => state.products.all }),
  methods: {
    getImage(item) {
      return require(`../assets/images/shop/${item.image}`);
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    buy(item) {
      this.$store.dispatch("cart/addProductToCart", item);
      this.$bvModal.show("add-to-cart-confirmation");
    },
  },
};
</script>

<style scoped lang="scss">
.shop-item {
  background: white;
  color: #3d5262;
  position: relative;

  h4 {
    font-weight: normal;
  }

  .title {
    line-height: 2rem;
    height: 14rem;
    overflow: hidden;
  }

  .buy {
    position: absolute;
    bottom: 0;
    right: 0;
    background: #e7e7e7;
    color: #7a8994;
    padding: 15px;
    cursor: pointer;
  }

  .price {
    position: absolute;
    bottom: 0;
    left: 0;
    color: var(--dark);
    padding: 15px;
    cursor: pointer;
  }
}
</style>
